import * as React from 'react'
import PropTypes from 'prop-types'
import CircularProgress from '@mui/material/CircularProgress'
import Typography from '@mui/material/Typography'
import Box from '@mui/material/Box'
import { ScreenCover, CenterDivOnScreen } from '../../styles'
import { busyCursorZIndex, screenBlockerZIndex } from '../../common'


function CircularProgressWithLabel(props) {
  const { value, msg, sufix } = props
  return (
      <ScreenCover zIndex={busyCursorZIndex}
      style={{
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: '20px',             
        boxSizing: 'border-box',     
        backdropFilter: 'blur(4px)', 
      }} 
      >
        <CenterDivOnScreen>
            <div 
            style={{
              display: 'flex', 
              justifyContent: 'center', 
              flexDirection: 'column', 
              alignItems: 'center',
              backgroundColor: '#fff',     
              padding: '30px 40px',       
              borderRadius: '12px',       
              boxShadow: '0 8px 20px rgba(0,0,0,0.2)', 
              border: '1px solid #ddd',   
              minWidth: '300px',          
              maxWidth: '90vw',
            }}
                >
                <CircularProgressShow {...props} />
                <Typography
                variant='caption'
                component='div'
                color='primary'
                >
                {`${msg}...${value}${sufix}`}
                </Typography>
            </div>
        </CenterDivOnScreen>
      </ScreenCover>
  )
}

function CircularProgressShow(props) {
  return (
    <Box
      sx={{
        position: 'relative',
        display: 'inline-flex',
      }}
    >
      <CircularProgress value={props.value} />    
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Typography
          variant='caption'
          component='div'
          sx={{ color: 'text.primary' }}
        >
          { props.value && `${Math.round(props.value)}${props.sufix}` }
        </Typography>
        
      </Box>
    </Box>
  )
}

CircularProgressWithLabel.propTypes = {
  /**
   * The value of the progress indicator for the determinate variant.
   * Value between 0 and 100.
   * @default 0
   */
  value: PropTypes.number.isRequired,
  msg: PropTypes.string.isRequired,
  sufix: PropTypes.string.isRequired,
}
export default CircularProgressWithLabel